import axios from 'axios';
import Auth from '../auth';
import { encryptPassword } from '../utilities/encryptPassword';
import { getIdEstadoFromNombre } from '../utilities/Seller/EstadoSeller';
export const url = "";
let lastOrdenesEncabezadoKey = null;
let lastOrdenesEncabezadoAt = 0;
let lastOrdenesEncabezadoData = null;
let lastPublicacionesEncabezadoKey = null;
let lastPublicacionesEncabezadoAt = 0;
let lastPublicacionesEncabezadoData = null;

const buildEmptyPublicacionesEncabezado = () => ({
    elementos: [],
    cantidades: {
        activos: 0,
        pendientes: 0,
        enRevision: 0,
        pausadosConStock: 0,
        pausadosSinStock: 0,
        conStockNoPublicados: 0
    },
    cantidadTotal: 0,
    cantidadPagina: 0,
    numeroPagina: 0
});

const normalizeOptionalSellerParam = (params) => {
    if (!params || typeof params !== 'object') {
        return params;
    }

    ['idSeller', 'IdSeller'].forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(params, key)) {
            return;
        }

        const rawValue = params[key];
        const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

        if (trimmedValue === '' || trimmedValue == null) {
            delete params[key];
            return;
        }

        const numericValue = Number(trimmedValue);
        if (Number.isNaN(numericValue) || numericValue <= 0) {
            delete params[key];
        }
    });

    return params;
};

const parseJsonIfNeeded = (rawData) => {
    if (typeof rawData !== 'string') {
        return rawData ?? {};
    }

    try {
        return JSON.parse(rawData);
    } catch (_) {
        return {};
    }
};

const normalizePublicacionesEncabezadoResponse = (rawData) => {
    const data = parseJsonIfNeeded(rawData);
    const empty = buildEmptyPublicacionesEncabezado();
    const rawCantidades = (data && typeof data === 'object' && data.cantidades && typeof data.cantidades === 'object')
        ? data.cantidades
        : {};

    if (Array.isArray(data?.elementos)) {
        return {
            ...empty,
            ...data,
            elementos: data.elementos
                .filter(item => item && typeof item === 'object')
                .map((item) => ({
                    ...item,
                    imagenes: Array.isArray(item?.imagenes)
                        ? item.imagenes
                        : (Array.isArray(item?.Imagenes) ? item.Imagenes : []),
                    descripcionUmbralStock: item?.descripcionUmbralStock ?? item?.DescripcionUmbralStock ?? ""
                })),
            cantidades: {
                ...empty.cantidades,
                ...rawCantidades,
                activos: rawCantidades?.activos ?? rawCantidades?.Activos ?? data?.activos ?? data?.Activos ?? 0,
                pendientes: rawCantidades?.pendientes ?? rawCantidades?.Pendientes ?? data?.pendientes ?? data?.Pendientes ?? 0,
                enRevision: rawCantidades?.enRevision ?? rawCantidades?.EnRevision ?? data?.enRevision ?? data?.EnRevision ?? 0,
                pausadosConStock: rawCantidades?.pausadosConStock ?? rawCantidades?.PausadosConStock ?? data?.pausadosConStock ?? data?.PausadosConStock ?? 0,
                pausadosSinStock: rawCantidades?.pausadosSinStock ?? rawCantidades?.PausadosSinStock ?? data?.pausadosSinStock ?? data?.PausadosSinStock ?? 0,
                conStockNoPublicados: rawCantidades?.conStockNoPublicados ?? rawCantidades?.ConStockNoPublicados ?? data?.conStockNoPublicados ?? data?.ConStockNoPublicados ?? 0
            },
            cantidadTotal: data?.cantidadTotal ?? data?.CantidadTotal ?? data?.total ?? data?.Total ?? 0,
            cantidadPagina: data?.cantidadPagina ?? data?.CantidadPagina ?? data?.totalPages ?? data?.TotalPages ?? 0,
            numeroPagina: data?.numeroPagina ?? data?.NumeroPagina ?? data?.page ?? data?.Page ?? 0
        };
    }

    const rawContent = Array.isArray(data?.content)
        ? data.content
        : (Array.isArray(data?.Content) ? data.Content : []);

    return {
        ...empty,
        elementos: rawContent
            .filter(item => item && typeof item === 'object')
            .map((item) => ({
                ...item,
                imagenes: Array.isArray(item?.imagenes)
                    ? item.imagenes
                    : (Array.isArray(item?.Imagenes) ? item.Imagenes : []),
                descripcionUmbralStock: item?.descripcionUmbralStock ?? item?.DescripcionUmbralStock ?? ""
            })),
        cantidades: {
            ...empty.cantidades,
            ...rawCantidades,
            activos: rawCantidades?.activos ?? rawCantidades?.Activos ?? data?.activos ?? data?.Activos ?? 0,
            pendientes: rawCantidades?.pendientes ?? rawCantidades?.Pendientes ?? data?.pendientes ?? data?.Pendientes ?? 0,
            enRevision: rawCantidades?.enRevision ?? rawCantidades?.EnRevision ?? data?.enRevision ?? data?.EnRevision ?? 0,
            pausadosConStock: rawCantidades?.pausadosConStock ?? rawCantidades?.PausadosConStock ?? data?.pausadosConStock ?? data?.PausadosConStock ?? 0,
            pausadosSinStock: rawCantidades?.pausadosSinStock ?? rawCantidades?.PausadosSinStock ?? data?.pausadosSinStock ?? data?.PausadosSinStock ?? 0,
            conStockNoPublicados: rawCantidades?.conStockNoPublicados ?? rawCantidades?.ConStockNoPublicados ?? data?.conStockNoPublicados ?? data?.ConStockNoPublicados ?? 0
        },
        cantidadTotal: data?.cantidadTotal ?? data?.CantidadTotal ?? data?.total ?? data?.Total ?? 0,
        cantidadPagina: data?.cantidadPagina ?? data?.CantidadPagina ?? data?.totalPages ?? data?.TotalPages ?? 0,
        numeroPagina: data?.numeroPagina ?? data?.NumeroPagina ?? data?.page ?? data?.Page ?? 0
    };
};

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';

        const esIntegracionOAuth =
            url.includes('/oauth/zipnova') ||
            url.includes('/api/oauth/');

        const esProxyBff =
            url.includes('/Proxy') ||
            url.includes('/EncabezadoProxy') ||
            url.includes('/EncabezadosProxy');

        const isLocalhostRuntime =
            typeof window !== 'undefined' &&
            window.location &&
            window.location.hostname === 'localhost';

        if (status === 401 && !esIntegracionOAuth && !esProxyBff && !isLocalhostRuntime) {
            Auth.logout();
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export const loginApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/login`,
            data: request
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const impersonateUserApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/account/impersonate`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getGrupoPlanesById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes/Planes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoById = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteGrupoPlanesById = (id) => {

    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Administracion/GrupoPlanes?id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getGrupoPlanes = (params) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/GrupoPlanes`,
            params: params ?? null
        }
        ).then(response => {
            const data = response?.data ?? {};
            const rawItems =
                Array.isArray(data?.elementos) ? data.elementos :
                    Array.isArray(data?.Elementos) ? data.Elementos :
                        Array.isArray(data?.content) ? data.content :
                            Array.isArray(data?.Content) ? data.Content :
                                Array.isArray(data?.paginationGrupoPlanes?.content) ? data.paginationGrupoPlanes.content :
                                    Array.isArray(data?.paginationGrupoPlanes?.Content) ? data.paginationGrupoPlanes.Content :
                                        [];

            const elementos = rawItems.map((item) => ({
                ...item,
                idGrupoPlan: item?.idGrupoPlan ?? item?.IdGrupoPlan ?? 0,
                descripcion: item?.descripcion ?? item?.Descripcion ?? "",
                comision: item?.comision ?? item?.Comision ?? 0,
                cantidadDeTipoPlanes: item?.cantidadDeTipoPlanes ?? item?.CantidadDeTipoPlanes ?? 0,
                cantidadPublicaciones: item?.cantidadPublicaciones ?? item?.CantidadPublicaciones ?? 0,
                estado: item?.estado ?? item?.Estado ?? 0
            }));

            const normalizedData = {
                ...data,
                elementos,
                total: data?.total ?? data?.Total ?? data?.cantidadTotal ?? data?.CantidadTotal ?? elementos.length,
                page: data?.page ?? data?.Page ?? data?.numeroPagina ?? data?.NumeroPagina ?? 1
            };

            resolve({
                ...response,
                data: normalizedData
            });
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getPlanesPorParametros = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Planes`,
            params: params ?? null
        }
        ).then(response => {
            const data = response?.data ?? {};
            const pagResumen = data?.paginationResumenPlanMkt ?? data?.PaginationResumenPlanMkt;
            const rawItems =
                Array.isArray(data?.elementos) ? data.elementos :
                    Array.isArray(data?.Elementos) ? data.Elementos :
                        Array.isArray(data?.content) ? data.content :
                            Array.isArray(data?.Content) ? data.Content :
                                Array.isArray(data?.paginationPlanes?.content) ? data.paginationPlanes.content :
                                    Array.isArray(data?.paginationPlanes?.Content) ? data.paginationPlanes.Content :
                                        Array.isArray(pagResumen?.content) ? pagResumen.content :
                                            Array.isArray(pagResumen?.Content) ? pagResumen.Content :
                                                [];

            const elementos = rawItems.map((item) => ({
                ...item,
                idPlan: item?.idPlan ?? item?.IdPlan ?? item?.id ?? item?.Id ?? 0,
                numero: item?.numero ?? item?.Numero ?? item?.numeroPlan ?? item?.NumeroPlan ?? 0,
                descripcion: item?.descripcion ?? item?.Descripcion ?? "",
                cuotas: item?.cuotas ?? item?.Cuotas ?? 0
            }));

            const normalizedData = {
                ...data,
                elementos,
                cantidadTotal: data?.cantidadTotal ?? data?.CantidadTotal ?? data?.total ?? data?.Total
                    ?? pagResumen?.total ?? pagResumen?.Total ?? elementos.length,
                numeroPagina: data?.numeroPagina ?? data?.NumeroPagina ?? data?.page ?? data?.Page
                    ?? pagResumen?.page ?? pagResumen?.Page ?? 1
            };

            resolve({
                ...response,
                data: normalizedData
            });
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/GrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDashboardTotalizadoresApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Dashboard/Totalizadores`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const obtenerUsuariosDeSeller = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/BuscarProxy`,
            params: params ?? null
        }
        ).then(response => {
            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve(response);
                return;
            }

            const normalized = {
                ...data,
                elementos: Array.isArray(data?.Elementos) ? data.Elementos : (Array.isArray(data?.content) ? data.content : []),
                cantidadTotal: data?.cantidadTotal ?? data?.CantidadTotal ?? data?.total ?? data?.Total ?? 0,
                cantidadPagina: data?.cantidadPagina ?? data?.CantidadPagina ?? data?.totalPages ?? data?.TotalPages ?? 0,
            };
            resolve({ ...response, data: normalized });
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postSearchUsuario = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/ObtenerUsuarioProxy`,
            params: data
        })
            .then(response => {
                const payload = response?.data ?? {};
                if (Array.isArray(payload?.usuario)) {
                    resolve(response);
                    return;
                }

                const normalized = {
                    ...payload,
                    usuario: Array.isArray(payload?.Usuario)
                        ? payload.Usuario
                        : (Array.isArray(payload?.usuario) ? payload.usuario : (payload?.idUsuario ? [payload] : []))
                };
                resolve({ ...response, data: normalized });
            })
            .catch(err => reject(err));
    });
};

export const postSearchTokenUsuario = (data) => {
    const normalizedData = {
        ...data,
        idUsuario: data?.idUsuario ?? data?.IdUsuario,
        IdUsuario: data?.IdUsuario ?? data?.idUsuario,
        method: data?.method ?? 1
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ObtenerTokenUsuarioProxy`,
            data: normalizedData,
            headers: { 'Content-Type': 'application/json' }
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const obtenerTiposUsuarioApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/GetTiposUsuario`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postChangeStateUsuario = (data) => {
    console.log(data, "🎀")
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CambiarEstado`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const modificarUsuario = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarGrupoPlanes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }

        ).catch(err => {
            reject(err);
        })
    })
}

export const postTiposPublicacionAsociarSeller = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion/AsociarSeller`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getTiposPublicacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/TiposPublicacion`,
            params: request
        }).then(response => {
            const data = response?.data ?? {};
            const paginationTipoPublicacion = data?.paginationTipoPublicacion ?? data?.PaginationTipoPublicacion ?? null;
            const rawItems =
                Array.isArray(data?.elementos) ? data.elementos :
                    Array.isArray(data?.Elementos) ? data.Elementos :
                        Array.isArray(data?.content) ? data.content :
                            Array.isArray(data?.Content) ? data.Content :
                                Array.isArray(paginationTipoPublicacion?.content) ? paginationTipoPublicacion.content :
                                    Array.isArray(paginationTipoPublicacion?.Content) ? paginationTipoPublicacion.Content :
                                Array.isArray(data?.paginationTiposPublicacion?.content) ? data.paginationTiposPublicacion.content :
                                    Array.isArray(data?.paginationTiposPublicacion?.Content) ? data.paginationTiposPublicacion.Content :
                                        Array.isArray(data?.data?.elementos) ? data.data.elementos :
                                            [];
            const elementos = rawItems.map((item) => {
                const rawGp = item?.grupoPlanes ?? item?.GrupoPlanes ?? [];
                const grupoPlanes = Array.isArray(rawGp)
                    ? rawGp.map((g) => ({
                        ...g,
                        idGrupoPlan: g?.idGrupoPlan ?? g?.IdGrupoPlan ?? 0,
                        descripcion: g?.descripcion ?? g?.Descripcion ?? "",
                        comision: g?.comision ?? g?.Comision ?? 0,
                        estado: g?.estado ?? g?.Estado ?? 0,
                        cantidadDeTipoPlanes: g?.cantidadDeTipoPlanes ?? g?.CantidadDeTipoPlanes ?? 0
                    }))
                    : [];
                return {
                    ...item,
                    idTipoPublicacion: item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? null,
                    codigo: item?.codigo ?? item?.Codigo ?? item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? 0,
                    descripcion: item?.descripcion ?? item?.Descripcion ?? "",
                    comision: item?.comision ?? item?.Comision ?? 0,
                    cantidadGrupoPlanes: item?.cantidadGrupoPlanes ?? item?.CantidadGrupoPlanes ?? 0,
                    cantidadPublicaciones: item?.cantidadPublicaciones ?? item?.CantidadPublicaciones ?? 0,
                    estado: item?.estado ?? item?.Estado ?? 0,
                    cantidadCuotas: item?.cantidadCuotas ?? item?.CantidadCuotas ?? 0,
                    grupoPlanes
                };
            });
            resolve({
                ...response,
                data: {
                    ...data,
                    elementos,
                    total: data?.total ?? data?.Total ?? data?.cantidadTotal ?? data?.CantidadTotal ?? paginationTipoPublicacion?.total ?? paginationTipoPublicacion?.Total ?? elementos.length,
                    page: data?.page ?? data?.Page ?? data?.numeroPagina ?? data?.NumeroPagina ?? paginationTipoPublicacion?.page ?? paginationTipoPublicacion?.Page ?? 1
                }
            });
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putAdministracionTiposPublicacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/TiposPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const deleteAdministracionTiposPublicacion = (id) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Administracion/TiposPublicacion?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postFacturaOrdenes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const postCrearOrden = (data) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CrearOrden`,
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getFacturaOrdenes = (idOrden, idEstado) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Comprobantes?IdOrden=${idOrden}&IdEstado=${idEstado}`,
        }
        ).then(response => {

            response.data.comprobantes.map((item) => {
                if (item.idEstado == idEstado) {
                    resolve(item.archivo);
                }
            })
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getComprobanteOrdenes = (idOrden) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Obleas?idOrden=${idOrden}`,
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchSellersApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchDesplegableProveedoresApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/DesplegableProveedores`,
            params: params ?? null
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchPublicacionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                ...params,
                DireccionOrdenamiento: 1,
                EntidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve(data);
                return;
            }

            resolve({
                elementos: Array.isArray(data?.content) ? data.content.map((item) => ({
                    ...item,
                    imagenes: Array.isArray(item?.imagenes) ? item.imagenes : Array.isArray(item?.Imagenes) ? item.Imagenes : []
                })) : [],
                cantidades: {
                    activos: data?.activos ?? 0,
                    enRevision: data?.enRevision ?? 0,
                    conStockNoPublicados: data?.conStockNoPublicados ?? 0
                },
                cantidadTotal: data?.total ?? data?.Total ?? 0,
                cantidadPagina: data?.totalPages ?? data?.TotalPages ?? 0,
                numeroPagina: data?.page ?? data?.Page ?? 0
            })
        }).catch(error => {
            reject(error);
        })
    });
}


export const fetchPublicacionesEncabezadoApi = (params) => {
    const requestParams = normalizeOptionalSellerParam({
        ...params,
        DireccionOrdenamiento: 1,
        EntidadOrdenamiento: "idPublicacion"
    });
    const requestKey = JSON.stringify(requestParams);
    const now = Date.now();
    const cacheWindowMs = 7000;
    if (
        requestKey === lastPublicacionesEncabezadoKey &&
        lastPublicacionesEncabezadoData &&
        (now - lastPublicacionesEncabezadoAt) < cacheWindowMs
    ) {
        return Promise.resolve(lastPublicacionesEncabezadoData);
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EncabezadosProxy`,
            params: requestParams
        }).then(response => {
            try {
                const normalized = normalizePublicacionesEncabezadoResponse(response?.data);

                lastPublicacionesEncabezadoKey = requestKey;
                lastPublicacionesEncabezadoAt = Date.now();
                lastPublicacionesEncabezadoData = normalized;
                resolve(normalized);
            } catch (e) {
                const fallback = buildEmptyPublicacionesEncabezado();
                lastPublicacionesEncabezadoKey = requestKey;
                lastPublicacionesEncabezadoAt = Date.now();
                lastPublicacionesEncabezadoData = fallback;
                resolve(fallback);
            }
        }).catch(error => {
            reject(error);
        })
    });
}



// export const fetchTipoPublicacionApi = (idSeller) => {

//         axios({
//             method: 'get',
//             url: `${url}/api/Tipos/Publicacion`,
//             params: { idSeller: idSeller }
//         }).then(response => {
//             resolve(response.data);
//         }).catch(error => {
//             reject(error);
//         })
//     })
// }

export const fetchTipoPublicacionApi = (idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Tipos`,
            params: { idSeller: idSeller }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchPublicacionApi = (id) => {
    const normalizeItem = (item) => ({
        ...item,
        imagenes: Array.isArray(item?.imagenes)
            ? item.imagenes
            : Array.isArray(item?.Imagenes)
                ? item.Imagenes
                : []
    });

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                idPublicacion: id,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve({
                    ...data,
                    elementos: data.elementos.map(normalizeItem)
                });
                return;
            }

            const normalized = {
                elementos: Array.isArray(data?.content)
                    ? data.content.map(normalizeItem)
                    : []
            };
            resolve(normalized);
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchPublicacionPorSkuMarketApi = (skuMarket) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Proxy`,
            params: {
                skuMarket: skuMarket,
                direccionOrdenamiento: 1,
                entidadOrdenamiento: "idPublicacion"
            }
        }).then(response => {
            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve(data);
                return;
            }

            const normalized = {
                elementos: Array.isArray(data?.content) ? data.content.map((item) => ({
                    ...item,
                    imagenes: Array.isArray(item?.imagenes) ? item.imagenes : Array.isArray(item?.Imagenes) ? item.Imagenes : []
                })) : []
            };
            resolve(normalized)
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchVariacionesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Variaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcasApi = (descripcion) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/Marcas`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchMarcaApi = (idMarca) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            // Marca por id (no detalle de artículo)
            url: `${url}/api/Articulos/Marcas/${encodeURIComponent(idMarca)}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then(response => {
            const data = response?.data ?? {};
            if (data?.marca) {
                resolve(data);
                return;
            }

            // Compatibilidad con respuestas sin wrapper { marca: ... }
            const marcasList =
                Array.isArray(data?.marcas) ? data.marcas :
                    Array.isArray(data?.Marcas) ? data.Marcas :
                        Array.isArray(data?.elementos) ? data.elementos :
                            Array.isArray(data?.Elementos) ? data.Elementos :
                                null;

            const marcaFromList = Array.isArray(marcasList)
                ? (marcasList.find(m => String(m?.codigo ?? m?.Codigo) === String(idMarca)) ?? marcasList[0])
                : null;

            const marca =
                data?.Marca
                ?? marcaFromList
                ?? data;
            resolve({
                ...data,
                marca: {
                    codigo: marca?.codigo ?? marca?.Codigo ?? 0,
                    descripcion: marca?.descripcion ?? marca?.Descripcion ?? ""
                }
            });
        }).catch((error) => {
            reject(error);
        })
    })
}


export const fetchCategoriasApi = (descripcion) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/SubFamiliasByParams`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion
            }
        }).then(response => {
            const data = response?.data ?? {};
            // Normalizar shapes comunes: { categorias: [...] } / { elementos: [...] } / array directo
            const categoriasArray =
                Array.isArray(data?.elementos) ? data.elementos :
                    Array.isArray(data?.Elementos) ? data.Elementos :
                        Array.isArray(data?.categorias) ? data.categorias :
                            Array.isArray(data?.Categorias) ? data.Categorias :
                                Array.isArray(data?.content) ? data.content :
                                    Array.isArray(data?.Content) ? data.Content :
                                        Array.isArray(data) ? data : [];
            resolve({
                ...data,
                elementos: categoriasArray
            });
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchCategoriaApi = (descripcion) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Articulos/SubFamilias`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                descripcion: descripcion,
            },
        }).then(response => {
            const data = response?.data ?? {};
            const categoriasArray =
                Array.isArray(data?.elementos) ? data.elementos :
                    Array.isArray(data?.Elementos) ? data.Elementos :
                        Array.isArray(data?.categorias) ? data.categorias :
                            Array.isArray(data?.Categorias) ? data.Categorias :
                                Array.isArray(data?.content) ? data.content :
                                    Array.isArray(data?.Content) ? data.Content :
                                        Array.isArray(data) ? data : [];
            resolve({
                ...data,
                elementos: categoriasArray
            });
        }).catch((error) => {
            reject(error);
        })
    })
}

export const createPublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePublicacionApi = (publicacion) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones`,
            data: publicacion
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateImagenesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ModificarImagenesBulk`,
            data: request
        }).then(response => {

            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updatePosicionesImagenesApi = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarPosicionImagenes`,
            data: request
        }).then(response => {

            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const deletePublicacionApi = (id) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Publicaciones?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosRevisionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosRevision`
        }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchMotivosSolicitudAnulacionApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/MotivosSolicitudAnulacion`
        }).then((response) => {
            const data = response?.data ?? {};
            const motivos =
                Array.isArray(data?.motivosSolicitudAnulacion) ? data.motivosSolicitudAnulacion :
                    Array.isArray(data?.MotivosSolicitudAnulacion) ? data.MotivosSolicitudAnulacion :
                        Array.isArray(data?.motivosSolicitud) ? data.motivosSolicitud :
                            Array.isArray(data?.MotivosSolicitud) ? data.MotivosSolicitud :
                                Array.isArray(data?.motivos) ? data.motivos :
                                    Array.isArray(data?.Motivos) ? data.Motivos :
                                        [];

            resolve({
                ...data,
                motivosSolicitudAnulacion: motivos
            });
        }).catch(error => {
            reject(error);
        })
    })
}

export const updatePublicacionEstadoVariacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/Variaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Aprobar`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const postDesaprobarPublicacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/Desaprobar`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteSellerApi = (id) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Seller?id=${id}`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const getOrden = (idOrden, idUsuario) => {

    let request = {
        IdOrden: idOrden,
        IdUsuario: idUsuario
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            const normalizePago = (rawPago) => {
                const pago = rawPago ?? {};
                const rawCupones = pago?.cupones ?? pago?.Cupones ?? [];
                return {
                    ...pago,
                    cuotas: pago?.cuotas ?? pago?.Cuotas ?? 0,
                    tarjeta: pago?.tarjeta ?? pago?.Tarjeta ?? "",
                    banco: pago?.banco ?? pago?.Banco ?? "",
                    medioPago: pago?.medioPago ?? pago?.MetodoPago ?? pago?.metodoPago ?? "",
                    cupones: Array.isArray(rawCupones) ? rawCupones.map((c) => ({
                        ...c,
                        nroPlan: c?.nroPlan ?? c?.NroPlan ?? 0,
                        montoCuota: c?.montoCuota ?? c?.MontoCuota ?? 0,
                        recargo: c?.recargo ?? c?.Recargo ?? 0,
                        idTransaccion: c?.idTransaccion ?? c?.IdTransaccion ?? "",
                        primerosSeisDigitos: c?.primerosSeisDigitos ?? c?.PrimerosSeisDigitos ?? "",
                        ultimosCuatroDigitos: c?.ultimosCuatroDigitos ?? c?.UltimosCuatroDigitos ?? "",
                        nroCupon: c?.nroCupon ?? c?.NroCupon ?? "",
                        adquiriente: c?.adquiriente ?? c?.Adquiriente ?? ""
                    })) : []
                };
            };

            const normalizeCliente = (item) => {
                const cliente = item?.cliente ?? item?.Cliente ?? item?.comprador ?? item?.Comprador ?? {};
                return {
                    nombre: cliente?.nombre ?? cliente?.Nombre ?? "",
                    apellido: cliente?.apellido ?? cliente?.Apellido ?? "",
                    email: cliente?.email ?? cliente?.Email ?? "",
                    documento: cliente?.dni ?? cliente?.Dni ?? cliente?.documento ?? cliente?.Documento ?? 0,
                    tipoDocumento: cliente?.tipoDocumento ?? cliente?.TipoDocumento ?? "DNI",
                    calle: cliente?.calle ?? cliente?.Calle ?? "",
                    numero: cliente?.numero ?? cliente?.Numero ?? "",
                    piso: cliente?.piso ?? cliente?.Piso ?? "",
                    departamento: cliente?.departamento ?? cliente?.Departamento ?? "",
                    codigoPostal: cliente?.codigoPostal ?? cliente?.CodigoPostal ?? "",
                    localidad: cliente?.localidad ?? cliente?.Localidad ?? "",
                    provincia: cliente?.provincia ?? cliente?.Provincia ?? "",
                    telefono: cliente?.telefono ?? cliente?.Telefono ?? ""
                };
            };

            const mapOrdenItem = (item) => ({
                idOrden: item?.idOrden ?? item?.IdOrden ?? 0,
                idReferencia: item?.idReferencia ?? item?.IdReferencia ?? null,
                fecha: item?.fecha ?? item?.Fecha ?? "",
                cliente: normalizeCliente(item),
                estado: Array.isArray(item?.estado) ? item.estado : (Array.isArray(item?.Estado) ? item.Estado : []),
                productos: Array.isArray(item?.productos) ? item.productos : (Array.isArray(item?.Productos) ? item.Productos : []),
                entrega: item?.entrega ?? item?.Entrega ?? { tipoEntrega: { codigo: 0, descripcion: "" } },
                pago: normalizePago(item?.pago ?? item?.Pago),
                seller: item?.seller ? {
                    codigo: item.seller?.codigo ?? item.seller?.idSeller ?? 0,
                    descripcion: item.seller?.descripcion ?? item.seller?.razonSocial ?? "",
                    urlLogo: item.seller?.urlLogo ?? null
                } : (item?.Seller ? {
                    codigo: item.Seller?.IdSeller ?? 0,
                    descripcion: item.Seller?.RazonSocial ?? "",
                    urlLogo: item.Seller?.UrlLogo ?? null
                } : { codigo: 0, descripcion: "", urlLogo: null })
            });

            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve(data);
                return;
            }

            const pag = data?.paginateOrdenes ?? {};
            let content = Array.isArray(pag?.content) ? pag.content : [];
            if (content.length === 0 && (data?.idOrden != null || data?.IdOrden != null)) {
                content = [data];
            }
            const normalized = {
                elementos: content.map(mapOrdenItem)
            };
            resolve(normalized);
        }).catch(err => {
            reject(err);
        })
    })
};

export const fetchOrdenesParams = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/Proxy`,
            params: request
        }).then(response => {
            const data = response?.data ?? {};
            if (Array.isArray(data?.elementos)) {
                resolve(data);
                return;
            }

            const pag = data?.paginateOrdenes ?? {};
            const content = Array.isArray(pag?.content) ? pag.content : [];
            const normalized = {
                montoTotalVentas: data?.montoTotalVentas ?? 0,
                montoTotalComision: data?.montoTotalComision ?? 0,
                cantidadTotal: pag?.total ?? 0,
                cantidadPagina: pag?.totalPages ?? 0,
                numeroPagina: pag?.page ?? 0,
                elementos: content.map((item) => ({
                    idOrden: item?.idOrden ?? item?.IdOrden ?? 0,
                    idReferencia: item?.idReferencia ?? item?.IdReferencia ?? null,
                    fecha: item?.fecha ?? item?.Fecha ?? "",
                    cliente: {
                        nombre: item?.cliente?.nombre ?? item?.Cliente?.Nombre ?? "",
                        apellido: item?.cliente?.apellido ?? item?.Cliente?.Apellido ?? "",
                        email: item?.cliente?.email ?? item?.Cliente?.Email ?? "",
                        documento: item?.cliente?.dni ?? item?.Cliente?.Documento ?? 0
                    },
                    productos: Array.isArray(item?.productos) ? item.productos : (Array.isArray(item?.Productos) ? item.Productos : []),
                    estado: Array.isArray(item?.estado) ? item.estado : (Array.isArray(item?.Estado) ? item.Estado : []),
                    entrega: item?.entrega ?? item?.Entrega ?? { tipoEntrega: { codigo: 0, descripcion: "" } },
                    pago: item?.pago ?? item?.Pago ?? {},
                    seller: item?.seller ? {
                        codigo: item.seller?.codigo ?? item.seller?.idSeller ?? 0,
                        descripcion: item.seller?.descripcion ?? item.seller?.razonSocial ?? "",
                        urlLogo: item.seller?.urlLogo ?? null
                    } : (item?.Seller ? {
                        codigo: item.Seller?.IdSeller ?? 0,
                        descripcion: item.Seller?.RazonSocial ?? "",
                        urlLogo: item.Seller?.UrlLogo ?? null
                    } : { codigo: 0, descripcion: "", urlLogo: null })
                }))
            };
            resolve(normalized);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEncabezadoParams = (request) => {
    const params = {
        ...request,
        page: request.numeroPagina,
        pageSize: request.cantidadPagina,
    };
    delete params.numeroPagina;
    delete params.cantidadPagina;
    normalizeOptionalSellerParam(params);

    const requestKey = JSON.stringify(params);
    const now = Date.now();
    const cacheWindowMs = 7000;
    if (requestKey === lastOrdenesEncabezadoKey && lastOrdenesEncabezadoData && (now - lastOrdenesEncabezadoAt) < cacheWindowMs) {
        return Promise.resolve(lastOrdenesEncabezadoData);
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/EncabezadoProxy`,
            params: params
        }).then(response => {
            const data = response?.data ?? {};

            if (Array.isArray(data?.elementos)) {
                lastOrdenesEncabezadoKey = requestKey;
                lastOrdenesEncabezadoAt = Date.now();
                lastOrdenesEncabezadoData = data;
                resolve(data);
                return;
            }

            const pag = data?.paginateOrdenes ?? {};
            const content = Array.isArray(pag?.content) ? pag.content : [];

            const normalized = {
                montoVentasTotal: data?.montoTotalVentas ?? 0,
                montoTotalVentasAnuladas: data?.montoTotalVentasAnuladas ?? 0,
                montoComisionTotal: data?.montoTotalComision ?? 0,
                cantidadTotal: pag?.total ?? 0,
                cantidadPagina: pag?.totalPages ?? 0,
                numeroPagina: pag?.page ?? 0,
                elementos: content.map((item) => ({
                    idOrden: item?.idOrden,
                    idReferencia: item?.idReferencia,
                    fecha: item?.fecha,
                    anulacionMegatone: {
                        anulado: item?.anulacionMegatone?.anulado ?? null,
                        motivoAnulacion: item?.anulacionMegatone?.motivoAnulacion ?? null
                    },
                    montoComision: item?.montoComision ?? 0,
                    montoVenta: item?.montoVenta ?? 0,
                    idVendedorBoca: item?.idVendedorBoca ?? null,
                    productos: Array.isArray(item?.productos) ? item.productos.map((producto) => ({
                        skuMarket: producto?.codProducto ?? producto?.skuMarket ?? "",
                        sellerSku: producto?.skuSeller ?? producto?.sellerSku ?? "",
                        precioUnitario: producto?.precioUnitario ?? 0,
                        titulo: producto?.titulo ?? "",
                        imagenPrincipal: producto?.imagenPrincipal ?? null,
                        cantidad: producto?.cantidad ?? null
                    })) : [],
                    cliente: {
                        nombre: item?.cliente?.nombre ?? "",
                        apellido: item?.cliente?.apellido ?? "",
                        email: item?.cliente?.email ?? "",
                        documento: item?.cliente?.dni ?? item?.cliente?.documento ?? 0
                    },
                    entrega: {
                        tipoEntrega: item?.tipoEntrega ? {
                            codigo: item.tipoEntrega?.codigo ?? 0,
                            descripcion: item.tipoEntrega?.descripcion ?? ""
                        } : (item?.entrega?.tipoEntrega ?? { codigo: 0, descripcion: "" })
                    },
                    estado: Array.isArray(item?.estadoOrden) ? item.estadoOrden.map((estado) => ({
                        idEstado: estado?.idEstado ?? 0,
                        descripcion: estado?.descripcion ?? "",
                        fecha: estado?.fecha ?? null
                    })) : (Array.isArray(item?.estado) ? item.estado : []),
                    plataforma: item?.tipoPlataforma ? {
                        codigo: item.tipoPlataforma?.codigo ?? 0,
                        descripcion: item.tipoPlataforma?.descripcion ?? ""
                    } : (item?.plataforma ?? { codigo: 0, descripcion: "" }),
                    seller: item?.seller ? {
                        urlLogo: item.seller?.urlLogo ?? null,
                        descripcion: item.seller?.razonSocial ?? item.seller?.descripcion ?? "",
                        codigo: item.seller?.idSeller ?? item.seller?.codigo ?? 0
                    } : { urlLogo: null, descripcion: "", codigo: 0 }
                }))
            };

            lastOrdenesEncabezadoKey = requestKey;
            lastOrdenesEncabezadoAt = Date.now();
            lastOrdenesEncabezadoData = normalized;
            resolve(normalized);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenesEnVerdeParams = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/OrdenesProveedores`,
            params: request
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObtenerEstadoVenta`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAnularOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnularEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postAprobarOrdenEstadoVentaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AprobarEstadoVenta`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postSolicitudAnulacionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/SolicitudAnulacion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postAnulacionReversionOrdenApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/AnulacionReversion`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error)
        })
    })
}

export const listSellers = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const listSellersParameters = (Descripcion, CantidadPagina, NumeroPagina) => {
    // Asignar valores por defecto si los parámetros son undefined o null
    const pageSize = CantidadPagina ?? 10;
    const page = NumeroPagina ?? 1;

    // Asegurar que los valores sean números válidos
    const validPageSize = parseInt(pageSize) || 10;
    const validPage = parseInt(page) || 1;

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?Descripcion=${Descripcion || ''}&PageSize=${validPageSize}&Page=${validPage}`
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getSeller = (IdSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/Buscar?IdSeller=${IdSeller}&NumeroPagina=1&CantidadPagina=1`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getIntegradores = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integrators`,
        }).then(response => {
            resolve(response.data.integradores);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTipoFacturacion = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Facturacion`,
        }).then(response => {
            resolve(response.data.tiposFacturacion);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getEstadosSeller = () => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Estados/Seller`,
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postSeller = (data) => {

    const safeInt = (value, defaultValue = 0) => {
        if (value === undefined || value === null || value === "") {
            return defaultValue;
        }
        const n = parseInt(value, 10);
        return Number.isFinite(n) ? n : defaultValue;
    };

    let idIntegrador = 1;
    if (data.integrador != null && typeof data.integrador === "object" && data.integrador.codigo != null) {
        idIntegrador = safeInt(data.integrador.codigo, 1);
    } else if (data.integrador != null && typeof data.integrador !== "object") {
        idIntegrador = safeInt(data.integrador, 1);
    }

    let idTipoFacturacion = 1;
    if (data.tipoFacturacion != null && typeof data.tipoFacturacion === "object" && data.tipoFacturacion.codigo != null) {
        idTipoFacturacion = safeInt(data.tipoFacturacion.codigo, 1);
    } else if (data.tipoFacturacion != null && typeof data.tipoFacturacion !== "object") {
        idTipoFacturacion = safeInt(data.tipoFacturacion, 1);
    }

    const modalidadEPK =
        data.modalidadEPK !== undefined && data.modalidadEPK !== null && data.modalidadEPK !== ""
            ? data.modalidadEPK
            : "s";

    // idEstado 0 o ausente rompe el alta en Core (FK / validación EF). Alinear con el texto "estado" del formulario (Moderador).
    let idEstado = safeInt(data.idEstado, 0);
    if (data.estado && typeof data.estado === 'string') {
        const mapped = getIdEstadoFromNombre(data.estado);
        if (mapped != null && mapped > 0) {
            idEstado = mapped;
        }
    }
    if (!idEstado || idEstado < 1) {
        idEstado = 1;
    }

    const trimStr = (v) => (v == null || v === undefined ? '' : String(v).trim());
    const cuitDigits = trimStr(data.cuit).replace(/\D/g, '');
    const idEmpresaPk = safeInt(data.idEmpresaEnviopack, 0);
    // 0 suele romper FK hacia Empresa Enviopack en Core; null = "sin empresa" si la columna es nullable.
    const idEmpresaEnvioPack = idEmpresaPk > 0 ? idEmpresaPk : null;

    let seller = {
        "idIntegrador": idIntegrador,
        "sufijo": trimStr(data.sufijo),
        "idEstado": idEstado,
        "idTipoFacturacion": idTipoFacturacion,
        "razonSocial": trimStr(data.razonSocial),
        "domicilio": trimStr(data.domicilio),
        "numeroDomicilio": safeInt(data.numeroDomicilio, 0),
        "localidad": trimStr(data.localidad),
        "provincia": trimStr(data.provincia),
        "codigoPostal": safeInt(data.codigoPostal, 0),
        "telefono": trimStr(data.telefono),
        "cuit": cuitDigits,
        "email": trimStr(data.email),
        "emailDespacho": (() => {
            const d = trimStr(data.emailDespacho);
            const m = trimStr(data.email);
            return d !== '' ? d : m;
        })(),
        "emailUsuario": trimStr(data.emailUsuario),
        "urlPushOrdenes": data.urlPushOrdenes != null && trimStr(data.urlPushOrdenes) !== '' ? trimStr(data.urlPushOrdenes) : "",
        "idEmpresaEnvioPack": idEmpresaEnvioPack,
        "modalidadEPK": modalidadEPK,
        "diasCorte": data.diasCorte != null && data.diasCorte !== "" ? safeInt(data.diasCorte, 0) : 0,
        "diasPlazoPago": data.diasPlazoPago != null && data.diasPlazoPago !== "" ? safeInt(data.diasPlazoPago, 0) : 0,
        "nombreTienda": trimStr(data.nombreTienda),
        "logo": data.logo != null && trimStr(data.logo) !== '' ? trimStr(data.logo) : "",
        "tiendaActiva": !!data.tiendaActiva,
        "usuario": trimStr(data.nombreUsuario),
        "password": encryptPassword(data.password),
        "envioPropio": data.envioPropio !== undefined ? data.envioPropio : false,
        "internacional": !!data.internacional,
        "etiquetaSellerResumen": (() => {
            const t = data.etiquetaSellerResumen != null ? trimStr(data.etiquetaSellerResumen) : '';
            return t !== '' ? t : null;
        })(),
        "promesaEntrega": safeInt(data.promesaEntrega, 0)
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postUser = (data) => {

    let seller = {
        "idUsuario": data.idUsuario,
        "idSeller": data.idSeller,
        "password": data.password,
        "usuario": data.usuario,
        "email": data.email,
        "enviarMail": data.enviarEmail,
        "tipoUsuario": data.tipoUsuario,
        "soloLectura": data.soloLectura,
        "idProveedor": data.idProveedor
    };

    return new Promise((resolve, reject) => {

        axios({
            method: 'post',
            url: `${url}/api/Usuarios`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}


export const editUser = (data) => {
    let seller = {
        "idUsuario": data.idUsuario,
        "idSeller": data.idSeller,
        "password": data.passwordActual,
        "nuevoPassword": data.nuevoPassword,
        "usuario": data.usuario,
        "email": data.email,
        "soloLectura": data.soloLectura,
        "identificadores": data.identificadores,
        "idTipoUsuario": data.tipoUsuario,
        "modulos": data.modulos,
        "baja": data.baja,
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${data.idUsuario}`,
            data: seller
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const putSeller = (data) => {

    const safeInt = (value, defaultValue = 0) => {
        if (value === undefined || value === null || value === "") {
            return defaultValue;
        }
        const n = parseInt(value, 10);
        return Number.isFinite(n) ? n : defaultValue;
    };

    // ActualizarSellerRequest.PromesaEntrega es string; si el seller trae número desde la API,
    // JSON con número rompe la deserialización ("could not be converted to System.String").
    const promesaEntregaApi = (() => {
        const v = data.promesaEntrega;
        if (v == null || v === "") return "";
        if (typeof v === "string") return v;
        if (typeof v === "number" || typeof v === "boolean") return String(v);
        return "";
    })();

    let idIntegrador = 1;
    if (data.integrador != null && typeof data.integrador === "object" && data.integrador.codigo != null) {
        idIntegrador = safeInt(data.integrador.codigo, 1);
    } else if (data.integrador != null && typeof data.integrador !== "object") {
        idIntegrador = safeInt(data.integrador, 1);
    }

    let idTipoFacturacion = 1;
    if (data.tipoFacturacion != null && typeof data.tipoFacturacion === "object" && data.tipoFacturacion.codigo != null) {
        idTipoFacturacion = safeInt(data.tipoFacturacion.codigo, 1);
    } else if (data.tipoFacturacion != null && typeof data.tipoFacturacion !== "object") {
        idTipoFacturacion = safeInt(data.tipoFacturacion, 1);
    }

    let seller = {
        "idSeller": data.codigo,
        "idIntegrador": idIntegrador,
        "razonSocial": data.razonSocial,
        "domicilio": data.domicilio,
        "numeroDomicilio": safeInt(data.numeroDomicilio, 0),
        "localidad": data.localidad,
        "provincia": data.provincia,
        "codigoPostal": safeInt(data.codigoPostal, 0),
        "telefono": data.telefono,
        "cuit": data.cuit,
        "email": data.email,
        "emailDespacho": data.emailDespacho,
        "emailUsuario": data.emailUsuario,
        "nombreUsuario": data.nombreUsuario,
        "urlPushOrdenes": data.urlPushOrdenes,
        "sufijo": data.sufijo,
        "idTipoFacturacion": idTipoFacturacion,
        "idEmpresaEnviopack": safeInt(data.idEmpresaEnviopack, 0),
        "modalidadEPK": data.modalidadEPK !== "" ? data.modalidadEPK : "e",
        "diasCorte": data.diasCorte != "" ? safeInt(data.diasCorte, 0) : 0,
        "diasPlazoPago": data.diasPlazoPago != "" ? safeInt(data.diasPlazoPago, 0) : 0,
        "nombreTienda": data.nombreTienda,
        "logo": data.logo,
        "tiendaActiva": data.tiendaActiva,
        "envioPropio": data.envioPropio,
        "internacional": data.internacional,
        "slugTienda": data.slugTienda,
        "emisionFacturaA": data.emisionFacturaA,
        "etiquetaSellerResumen": data.etiquetaSellerResumen,
        "promesaEntrega": promesaEntregaApi
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller`,
            data: seller
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const createImageUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise((resolve, reject) => {
            axios({
                "url": "/Imagen",
                "method": "POST",
                "timeout": 0,
                "data": form
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    } else {
        return Promise.reject("Archivo incorrecto");
    }
}

export const createImageSellerUrl = (img) => {

    if (img.type.includes("image")) {
        let form = new FormData();

        form.append('', img, img.name);

        return new Promise((resolve, reject) => {
            axios({
                "url": "/Imagen/Seller",
                "method": "POST",
                "timeout": 0,
                "data": form
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    } else {
        return Promise.reject("Archivo incorrecto");
    }
}

export const leerExcelPublicaciones = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcel",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const leerExcelPublicacionesPorCodigo = (formularioCompleto) => {
    return new Promise(resolve => {
        axios({
            "dataType": "html",
            "url": "/PublicacionesExcelPorCodigo",
            "method": "POST",
            "timeout": 0,
            "processData": false,
            "contentType": false,
            "data": formularioCompleto
        }).then(res => {
            resolve(res);
        })
    });
}

export const postCreacionMasivaPublicacionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CreacionMasiva`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicaciones = (data) => {

    let listaAtributos = {
        "listaAtributos": data
    };

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasiva`,
            data: listaAtributos
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postExcelPublicacionesModerador = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPorCodigo`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelPublicacionesTipoYEnvioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaTipoYEnvio`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putExcelLiquidacionesFeeLogisticoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionMasivaFeeLogistico`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getFeeLogisticoSellersApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/FeeLogistico`
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDatosFeeLogisticoSellersApi = (VigenciaFeeLogistico) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/DatosFeeLogisticoSellers`,
            params: { VigenciaFeeLogistico }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}


export const fetchRebatesDeLiquidacionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/Rebates`,
            params: request
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLocalidades = (params) => {
    let params_1 = { ...params, NumeroPagina: 1, CantidadPagina: 500 };
    return new Promise((resolve) => {
        axios({
            method: 'get',
            url: `${url}/api/Localidades`,
            params: (params_1) ? params_1 : null
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            resolve(error);
        })
    })
}

export const getSituacionIva = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/SituacionIva`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}


export const getTiposAdquirientes = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Adquirientes`
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTiposSexo = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/Sexo`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionesListaSellers = () => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'get',
            url: `${url}/api/Seller/TraerSellerLiquidaciones`
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * Obtiene el array de conceptos desde cualquier forma habitual del BFF / API remoto.
 */
function extractConceptosNovedadesRawList(raw) {
    let data = raw;
    if (data == null) return [];
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        } catch {
            return [];
        }
    }
    if (Array.isArray(data)) return data;

    const keyCandidates = [
        'listaConceptoNovedades', 'ListaConceptoNovedades',
        'tiposNovedades', 'TiposNovedades',
        'conceptos', 'Conceptos',
        'tiposConceptos', 'TiposConceptos',
        'listaConceptos', 'ListaConceptos',
        'elementos', 'Elementos',
        'content', 'Content',
        'items', 'Items',
        'result', 'Result',
        'resultados', 'Resultados',
        'datos', 'Datos',
        'value', 'Value'
    ];

    const pickFromObject = (obj) => {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return [];
        for (const k of keyCandidates) {
            const v = obj[k];
            if (Array.isArray(v)) return v;
        }
        return [];
    };

    let list = pickFromObject(data);
    if (list.length) return list;

    const nestedRoots = ['data', 'Data', 'result', 'Result', 'payload', 'Payload', 'response', 'Response'];
    for (const nr of nestedRoots) {
        const inner = data[nr];
        if (inner == null || typeof inner !== 'object') continue;
        list = pickFromObject(inner);
        if (list.length) return list;
        if (Array.isArray(inner)) return inner;
    }

    if (data.data != null && typeof data.data === 'object') {
        list = pickFromObject(data.data);
        if (list.length) return list;
        if (Array.isArray(data.data)) return data.data;
    }

    if (data.result != null && typeof data.result === 'object' && !Array.isArray(data.result)) {
        list = pickFromObject(data.result);
        if (list.length) return list;
    }

    const looksConceptoItem = (x) => x && typeof x === 'object' && (
        'idTipoNovedad' in x || 'IdTipoNovedad' in x
        || 'idConcepto' in x || 'IdConcepto' in x
        || 'concepto' in x || 'Concepto' in x
        || 'descripcionSubTipoNovedad' in x || 'DescripcionSubTipoNovedad' in x
        || 'descripcionSubTipo' in x || 'DescripcionSubTipo' in x
        || 'idSubTipo' in x || 'IdSubTipo' in x
    );

    const firstMatchingArray = (obj) => {
        if (!obj || typeof obj !== 'object') return [];
        for (const v of Object.values(obj)) {
            if (!Array.isArray(v) || v.length === 0) continue;
            if (looksConceptoItem(v[0])) return v;
        }
        for (const v of Object.values(obj)) {
            if (Array.isArray(v) && v.length > 0 && looksConceptoItem(v[0])) return v;
        }
        return [];
    };

    list = firstMatchingArray(data);
    if (list.length) return list;
    if (data.data && typeof data.data === 'object') {
        list = firstMatchingArray(data.data);
        if (list.length) return list;
    }

    return [];
}

export const getTiposConceptos = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Tipos/TraerConceptoNovedad`
        }).then(response => {
            const data = response.data;
            const rawList = extractConceptosNovedadesRawList(data);

            const normalizedList = rawList.map((item) => ({
                ...item,
                idConcepto: item?.idConcepto ?? item?.IdConcepto ?? item?.concepto ?? item?.Concepto ?? item?.id ?? item?.Id ?? item?.codigo ?? item?.Codigo ?? "",
                idTipoNovedad: item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? item?.accion?.id ?? item?.Accion?.Id ?? 0,
                idSubTipo: item?.idSubTipo ?? item?.IdSubTipo ?? item?.idTipoNovedad ?? item?.IdTipoNovedad ?? item?.idAccion ?? item?.IdAccion ?? 0,
                detalleConcepto: item?.detalleConcepto ?? item?.DetalleConcepto ?? item?.concepto ?? item?.Concepto ?? item?.descripcion ?? item?.Descripcion ?? "",
                descripcionSubTipoNovedad: item?.descripcionSubTipoNovedad ?? item?.DescripcionSubTipoNovedad ?? item?.descripcionSubTipo ?? item?.DescripcionSubTipo ?? item?.accion?.descripcion ?? item?.Accion?.Descripcion ?? item?.descripcion ?? item?.Descripcion ?? "",
                mostrarBotonEliminar: item?.mostrarBotonEliminar ?? item?.MostrarBotonEliminar ?? true
            }));

            resolve({
                ...data,
                listaConceptoNovedades: normalizedList
            })
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionporid = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ConsultarDetalleLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getOrdenesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesPorFecha`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getNovedadesParaNuevaLiquidacion = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedades`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getLiquidacionPorIdOrdenes = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarOrdenesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLogistica = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/Cotizaciones`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getLiquidacionPorIdNovedades = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedadesDeLiquidacion`,
            params: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postNovedad = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearLiquidacionFinal`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaLiquidacionFinalLogistica = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/EnvioPack/Cotizaciones`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postNuevaNovedadConcepto = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearNovedadConcepto`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesLiquidaciones = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerAccionesNovedades`
        }).then(response => {
            const data = response?.data ?? {};
            const listadoNovedadesSubtipo =
                Array.isArray(data?.listadoNovedadesSubtipo) ? data.listadoNovedadesSubtipo :
                    Array.isArray(data?.ListadoNovedadesSubtipo) ? data.ListadoNovedadesSubtipo :
                        Array.isArray(data?.subTiposNovedades) ? data.subTiposNovedades :
                            Array.isArray(data?.SubTiposNovedades) ? data.SubTiposNovedades :
                                Array.isArray(data?.elementos) ? data.elementos :
                                    Array.isArray(data?.Elementos) ? data.Elementos :
                                        Array.isArray(data?.content) ? data.content :
                                            Array.isArray(data?.Content) ? data.Content :
                                                Array.isArray(data?.data) ? data.data : [];
            resolve({
                ...data,
                listadoNovedadesSubtipo
            })
        }).catch(error => {
            reject(error)
        })
    })
}

export const getEstadosLiquidaciones = () => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerEstadosLiquidaciones`
        }).then(response => {
            const data = response?.data ?? {};
            const listadoEstadosNovedades =
                Array.isArray(data.listadoEstadosNovedades) ? data.listadoEstadosNovedades :
                    Array.isArray(data.ListadoEstadosNovedades) ? data.ListadoEstadosNovedades :
                        Array.isArray(data.estados) ? data.estados :
                            Array.isArray(data.Estados) ? data.Estados : [];
            resolve({
                ...data,
                listadoEstadosNovedades
            });
        }).catch(error => {
            reject(error)
        })
    })
}

export const getEstadosLiquidacionesCorrecto = () => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TraerEstadosLiquidacionesCorrecto`
        }).then(response => {
            const data = response?.data ?? {};
            const listadoEstadosLiquidaciones =
                Array.isArray(data.listadoEstadosLiquidaciones) ? data.listadoEstadosLiquidaciones :
                    Array.isArray(data.ListadoEstadosLiquidaciones) ? data.ListadoEstadosLiquidaciones :
                        Array.isArray(data.estados) ? data.estados :
                            [];
            resolve({
                ...data,
                listadoEstadosLiquidaciones
            });
        }).catch(error => {
            reject(error)
        })
    })
}

export const getResultadosLiquidaciones = (request) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/BuscarNovedades`,
            params: request
        }).then(response => {
            const data = response?.data ?? {};
            const novedades =
                Array.isArray(data?.novedades) ? data.novedades :
                    Array.isArray(data?.Novedades) ? data.Novedades :
                        Array.isArray(data?.elementos) ? data.elementos :
                            Array.isArray(data?.content) ? data.content :
                                Array.isArray(data?.data) ? data.data : [];
            resolve({
                ...data,
                novedades
            });
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLiquidacionesBusqueda = (request) => {
    const params = request ? { ...request } : {};
    if (params.cantidadPagina != null && params.tamanoPagina == null) {
        params.tamanoPagina = params.cantidadPagina;
        delete params.cantidadPagina;
    }
    const rawId = params.idLiquidacion ?? params.IdLiquidacion;
    if (rawId === '' || rawId === undefined || rawId === null) {
        delete params.idLiquidacion;
        delete params.IdLiquidacion;
    } else if (typeof rawId === 'string') {
        const n = parseInt(String(rawId).trim(), 10);
        if (Number.isNaN(n) || n < 1) {
            delete params.idLiquidacion;
            delete params.IdLiquidacion;
        } else {
            params.idLiquidacion = n;
            delete params.IdLiquidacion;
        }
    } else if (typeof rawId === 'number') {
        if (rawId < 1) {
            delete params.idLiquidacion;
            delete params.IdLiquidacion;
        } else {
            params.idLiquidacion = rawId;
            delete params.IdLiquidacion;
        }
    }

    const numPag = params.numeroPagina ?? params.NumeroPagina ?? 1;
    const tamPag = params.tamanoPagina ?? params.TamanoPagina ?? 10;
    delete params.numeroPagina;
    delete params.NumeroPagina;
    delete params.tamanoPagina;
    delete params.TamanoPagina;
    delete params.cantidadPagina;
    params.NumeroPagina = numPag;
    params.TamanoPagina = tamPag;

    if (params.idLiquidacion != null) {
        params.IdLiquidacion = params.idLiquidacion;
        delete params.idLiquidacion;
    }

    if (params.fechaDesde != null && params.FechaDesde == null) {
        params.FechaDesde = params.fechaDesde;
        delete params.fechaDesde;
    }
    if (params.fechaHasta != null && params.FechaHasta == null) {
        params.FechaHasta = params.fechaHasta;
        delete params.fechaHasta;
    }
    if (params.idSeller != null && params.IdSeller == null) {
        params.IdSeller = params.idSeller;
        delete params.idSeller;
    }
    if (params.idEstado != null && params.IdEstado == null) {
        params.IdEstado = params.idEstado;
        delete params.idEstado;
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/LiquidacionesBusqueda`,
            params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaNovedadFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/AnularNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaConceptoFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/AnularConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEliminaLiquidacionFinal = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EliminarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);

        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaConceptoFinal = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizarConceptoNovedad`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putEditaLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const putConfirmarLiquidacion = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ConfirmarLiquidacion`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}


export const putEditaNovedadImporte = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/EditarNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postFacturarLiquidacionApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidacion/FacturarLiquidacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
};

export const putConfirmaNovedad = (data) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ConfirmaNovedad`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchExportarPublicacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Publicaciones`,
            params: {
                FechaPubDesde: request?.fechaPubDesde ?? request?.FechaPubDesde ?? null,
                FechaPubHasta: request?.fechaPubHasta ?? request?.FechaPubHasta ?? null,
                IdSeller: request?.idSeller ?? request?.IdSeller ?? null,
                Categoria: request?.categoria ?? request?.Categoria ?? null,
                Marca: request?.marca ?? request?.Marca ?? null,
                Estado: request?.estado ?? request?.Estado ?? null,
                SkuSeller: request?.skuSeller ?? request?.SkuSeller ?? null,
                SkuMarket: request?.skuMarket ?? request?.SkuMarket ?? null,
                IdTipoPubli: request?.idTipoPubli ?? request?.IdTipoPubli ?? null,
                SinStock: request?.sinStock ?? request?.SinStock ?? null,
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};






export const fetchExportarOrdenesApi = (request) => {
    return new Promise((resolve, reject) => {
        // POST: el BFF reenvía el body como query a la API externa. GET con `data` no envía filtros.
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ExportarOrdenes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarOrdenesTelefonicasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/ExportarOrdenesTelefonicas`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Liquidaciones`,
            params: {
                idLiquidacion: request?.idLiquidacion ?? request?.IdLiquidacion ?? request?.id ?? request?.Id ?? null
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Sellers`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarMarcasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/Marcas`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarCategoriasApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Exportables/SubFamilias`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const requestTokenResetPassword = (Email) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/Api/Usuarios/TokenResetPassword?Email=${Email}`
        }).then(response => {
            const AUTH_TOKEN = 'Bearer ' + response.data.token;
            window.localStorage.setItem("token", AUTH_TOKEN);
            axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postResetPassword = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ResetPassword`,
            data: data
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const fetchTotalNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Landing/Notificaciones/Total`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchDetalleNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/Detalle`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchMarcarLeidasNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Notificaciones/MarcarLeidas`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Notificaciones/Ajustes`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateAjusteNotificacionesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Notificaciones/Ajustes`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/Buscar`,
            params: { IdPublicacion: request }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchListRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Rebates/ListarRebates`,
            params: request
        }).then(response => {
            const data = response?.data ?? {};
            const rebatesResponse = data?.rebatesResponse ?? data?.RebatesResponse ?? {};
            const content =
                Array.isArray(data?.content) ? data.content :
                    Array.isArray(data?.Content) ? data.Content :
                        Array.isArray(data?.elementos) ? data.elementos :
                            Array.isArray(data?.Elementos) ? data.Elementos :
                                Array.isArray(rebatesResponse?.content) ? rebatesResponse.content :
                                    Array.isArray(rebatesResponse?.Content) ? rebatesResponse.Content :
                                Array.isArray(data?.rebates) ? data.rebates :
                                    Array.isArray(data?.rebates?.content) ? data.rebates.content :
                                        Array.isArray(data?.data) ? data.data : [];
            resolve({
                ...data,
                content,
                total: data?.total ?? data?.Total ?? data?.cantidadTotal ?? data?.CantidadTotal ?? rebatesResponse?.total ?? rebatesResponse?.Total ?? content.length
            });
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchExportarLiquidacionExcelApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarLiquidacionExcel`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Nuevo`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Rebates/Modificar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const deleteRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Rebates?id=${request}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postAprobarRebatesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Rebates/Aprobar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchComprobanteVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const guardarDescargaObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ObleaVentaVerde`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchLogisticaPropiaApi = (idSeller) => {
    return axios.get(`${url}/api/LogisticaPropia`, {
        params: { idSeller: Number(idSeller) }
    })
        .then(response => {
            return response.data;
        })
        .catch(error => {
            throw error;
        });
};


export const estructuraFeeLogistico = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/EstructuraFee`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogistico = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CrearFee`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const updateLogisticaPropiaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/LogisticaPropia`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateFeeLogisticoSellersApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionFeeLogisticoSellers`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateFeeLogisticosActivoProximo = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Liquidaciones/ActualizacionFeeMegatone`,
            data: request
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const descargarObleaVentaVerdeApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Ordenes/DescargarObleaVentaVerde`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const fetchGarantiasApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Garantias`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const updateUrlTrackingApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/ActualizarUrlTracking`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const putEstadoSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoSeller`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionPrecioYStockBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizacionMasivaPrecioYStockBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const updatePublicacionDimensionesBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/ActualizarDimensionesBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const updatePublicacionEstadoBulkApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Publicaciones/CambiarEstadoPublicacionBulk`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}
export const getLiquidacionPdf = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/LiquidacionPdf`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

/** Subida de PDF de comprobantes (admin/category). Body JSON { archivo: base64 } → api/Liquidacion/ComprobantesPago/Procesar. */
export const postComprobantesLiquidacionPdfApi = (payload) => {
    return axios({
        method: 'post',
        url: `${url}/api/Liquidaciones/ComprobantesPdf`,
        data: payload,
        headers: { 'Content-Type': 'application/json' }
    })
}

/** Comprobante de pago por idSeller — JSON { errores, archivo } (archivo = base64 PDF). Ruta = Swagger (Comrobante con "r"). */
export const getExportablesComprobanteDePagoApi = (params) => {
    return axios({
        method: 'get',
        url: `${url}/api/Exportables/Liquidaciones/ComrobanteDePago`,
        params
    })
}

export const fetchExportarCertificadosPdfApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarCertificadosPdf`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarCertificadoImpuestosAnexoApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarCertificadoImpuestosAnexos`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchExportarRetencionesYPercepcionesApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/ExportarRetencionesYPercepciones`,
            params: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postCalcularPercepcionRetencionApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Liquidaciones/CalcularPercepcionRetencionesLiquidacion`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getTipoComprobantesApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/TiposComprobantes`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAlicuotaIvaApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AlicuotasIva`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const postCrearCdnSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CrearCdnSeller`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deleteCdnSellerApi = (id) => {
    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Seller/EliminarCdnSeller`,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
            params: {
                Id: id,
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateCdnSellerApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/EditarCdnSeller`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getDetallesRetenciones = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Liquidaciones/CargasTributarias`,
            params: {
                idLiquidacion: id
            }
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getProvinciaLocalidadByCodigoPostalApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerLocalidadProvincia`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const enlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/EnlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const confirmarMfaApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/ConfirmarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const desenlazarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const deshabilitarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/DesenlazarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postVerificarMfaUsuarioApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/VerificarMfa`,
            data: request
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

export const postCargarDatosBancariosApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancarios`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getDatosBancariosApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerDatosBancariosSeller`,
            params: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postMasivaImagenesExcelApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargaMasivaImagenesExcel`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const getFormatoExcel = ({ tipoExcel }) => {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/api/Exportables/Publicaciones/ModelosExcel`, {
            params: { TipoModeloExcel: tipoExcel }
        })
            .then(resp => {
                resolve(resp);
            })
            .catch(err => {
                reject(err);
            });
    });
};

//export const getTotalizadores = (idSeller) => {
export const getTotalizadores = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/Totalizadores`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getEstadoResumen = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/ResumenEstados`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getTopProducto = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopProducto`,
            params: params ?? null
        })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const getTopCategorias = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopCategorias`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getTopTipoPublicaciones = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopTipoPublicaciones`,
            params: params ?? null
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const getVentasMensuales = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/VentasMensuales`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export const postChatBot = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatBot`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postTicket = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/Ticket`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const fetchAgentsApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const postIniciarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatIniciar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postFinalizarChat = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatFinalizar`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}


export const postCrearChatInterno = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatCrear`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const postChatMensaje = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Administracion/ChatMensaje`,
            data: request
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}

export const updateEstadoTiposPublicaciones = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/EstadoTipoPublicacion`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const fetchGlobal = (searchValue, idSeller) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/BusquedaGlobal`,
            params: {
                entrada: searchValue,
                idSeller: idSeller
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const getChatInterno = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/Categorys`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}
// export const getChatToken = (userId = null) => {

//         const params = userId ? `?userId=${userId}` : '';
//         axios({
//             method: 'get',
//             url: `${url}/api/Administracion/GetChatToken${params}`,
//             // No incluir headers de autorización porque es para obtener el token inicial
//         }).then(response => {
//             resolve(response.data);
//         }).catch(error => {
//             reject(error);
//         })
//     })
// }

export const fetchBancosApi = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/ObtenerBancos`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const postCargarDatosBancariosManualApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Seller/CargarDatosBancariosManual`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getlistGestionDatosBancariosSellersTesoreria = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Seller/GestionDatosBancariosSellersTesoreria`,
            params: { estado: request.estado }
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const updateEstadoBancarioCbuSellerApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Seller/CambiarEstadoDatoBancario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// export const getChatToken = (userId = null) => {

//     const params = userId ? `?userId=${userId}` : '';
//     axios({
//       method: 'get',
//       url: `${url}/api/Administracion/GetChatToken${params}`,
//       withCredentials: true // <= para que se setee/envíe la cookie
//     }).then(response => resolve(response.data))
//       .catch(reject);
//   });
// };

export const getChatInternoGrupo = (id) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Administracion/ChatInterno/Grupo/${id}`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export const updateEstadoGrupoPlanes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Administracion/EstadoGrupoPlanes`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}


export const putActivarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${id}/Activar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putActivarUsuario error", err.response);
            reject(err);
        })
    })
}

export const putPausarUsuario = (id) => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/${id}/Pausar`,
            data: {},
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            console.error("DEBUG: putPausarUsuario error", err.response);
            reject(err);

        })
    })
}


export const getTiposUsuarios = (id = null) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: id
                ? `${url}/api/Usuarios/ObtenerTipoUsuario?id=${id}`
                : `${url}/api/Usuarios/ObtenerTipoUsuario`,
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const postTiposUsuarios = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/CrearTipoUsuario`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const deleteTiposUsuarios = (id) => {

    return new Promise((resolve, reject) => {

        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/EliminarTipoUsuario?Id=${id}`,
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const updateTiposUsuarios = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Usuarios/ModificarTipoUsuario`,
            data: request
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)

        })
    })
}

export const postCargaMasivaComprobantesApi = (request) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Ordenes/CargarMasivaComprobantes`,
            data: request
        }).then((response) => {
            resolve(response)
        }).catch(error => {
            reject(error);
        })
    })
}

export const putModificarMasivaComprobantes = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'put',
            url: `${url}/api/Ordenes/ModificarMasivaComprobantes`,
            data: data
        }
        ).then(response => {
            resolve(response);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesPredefinidasTipoUsuarioApi = (idTipoUsuario) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/GetAccionesPredefinidasTipoUsuario`,
            params: { idTipoUsuario: idTipoUsuario }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const postAccionPredefinidaTipoUsuarioApi = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Usuarios/PostAccionPredefinidaTipoUsuario`,
            data: data
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getTopSellers = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopSellers`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}

export const getTipoPublicaciones = () => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Dashboard/TopTipoPublicaciones`,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    });
}


export const deleteAccionPredefinidaTipoUsuarioApi = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Usuarios/DeleteAccionPredefinidaTipoUsuario`,
            params: { id: id }
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAccionesApi = (params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Usuarios/GetAcciones`,
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const autorizarZipnova = (userId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Integraciones/Proveedor/Autorizar`,
            params: {
                IdUsuario: userId,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const estadoZipnova = (userId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Integraciones/Proveedor/Estado`,
            params: {
                IdUsuario: userId,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const desconectarZipnova = (userId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'delete',
            url: `${url}/api/Integraciones/Proveedor/Desconectar`,
            params: {
                IdUsuario: userId,
                Proveedor: 1
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
};

export const getSellerDesplegable = (params) => {
    return new Promise((resolve, reject) => {
        const p = params ?? {};
        // Normalizar nombres de query params para el backend externo (suele esperar camel/lowercase)
        const normalizedParams = {
            ...p,
            ...(p.Descripcion != null && p.descripcion == null ? { descripcion: p.Descripcion } : null),
            ...(p.Page != null && p.page == null ? { page: p.Page } : null),
            ...(p.PageSize != null && p.pageSize == null ? { pageSize: p.PageSize } : null),
        };
        const token = (typeof window !== "undefined" && window.localStorage)
            ? window.localStorage.getItem("token")
            : null;
        axios({
            method: 'get',
            url: `${url}/api/Seller/DesplegableSeller`,
            params: normalizedParams,
            headers: token ? { Authorization: token } : undefined
        }).then(response => {
            // A veces el proxy devuelve JSON como string (por Content-Type no json)
            let data = response?.data;
            if (typeof data === 'string') {
                try {
                    // soportar doble-serialización (string JSON dentro de string)
                    const first = JSON.parse(data);
                    data = (typeof first === 'string') ? JSON.parse(first) : first;
                } catch (_) { /* keep as string */ }
            }
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}


export const fetchAtributosCategoriaApi = (idSubFamilia) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria`,
            params: {
                idSubFamilia: idSubFamilia
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAtributosPorCategoriaAgrupamientoApi = (idSubFamilia, idAgrupacion, descripcion) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/AtributosCategoria`,
            params: {
                idSubFamilia: idSubFamilia,
                idAgrupacion: idAgrupacion,
                descripcion: descripcion
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchValoresAtributoApi = (idAtributo, descripcion) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/ValoresAtributo`,
            params: {
                idAtributo: idAtributo,
                descripcion: descripcion
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchEstructuraAtributosValoresApi = (codProducto, idCategoria) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/EstructuraAtributosValores`,
            params: {
                codProducto: codProducto,
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const fetchAgrupamientosApi = (idCategoria) => {

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `${url}/api/Publicaciones/Agrupamientos`,
            params: {
                idCategoria: idCategoria
            }
        }
        ).then(response => {
            resolve(response.data);
        }
        ).catch(err => {
            reject(err);
        })
    })
}

export const CargarAtributosApi = (valores) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: `${url}/api/Publicaciones/CargarAtributos`,
            data: valores
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error)
        })
    })
}
